import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FlaskConical } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", company: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await register(form.name, form.email, form.password, form.company);
    setLoading(false);
    if (res.success) navigate("/account");
    else setError(res.error);
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="register-page">
      <div className="text-center mb-8">
        <FlaskConical className="h-8 w-8 text-brandblue-600 mx-auto mb-3" strokeWidth={1.5} />
        <h1 className="text-2xl font-display font-medium text-slate-900">Create Research Account</h1>
        <p className="text-sm text-slate-500 mt-1">Register to track orders and save addresses.</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div><Label>Full Name</Label><Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name-input" /></div>
        <div><Label>Company / Institution (optional)</Label><Input value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} placeholder="Laboratory, university, or research organization" data-testid="register-company-input" /></div>
        <div><Label>Email</Label><Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email-input" /></div>
        <div><Label>Password</Label><Input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password-input" /></div>
        {error && <p className="text-xs text-red-500" data-testid="register-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full rounded-full btn-lift" data-testid="register-submit-btn">
          {loading ? "Creating Account..." : "Create Account"}
        </Button>
      </form>

      <p className="text-sm text-slate-500 text-center mt-5">Already have an account? <Link to="/login" className="text-brandblue-600 font-semibold" data-testid="go-to-login-link">Research Login</Link></p>
    </div>
  );
}
